import IonIcon from '@reacticons/ionicons'
import Link from 'next/link'
import React from 'react'
import { formatNumericDisplayDate } from 'src/utils/formatNumericDisplayDate'

interface AnnouncementNotificationProps {
  announcement?: string
  publishedAt: any
  optionalLink?: any
}

/**
 * Primary UI component for user interaction
 */
export const AnnouncementNotification: React.FC<AnnouncementNotificationProps> = ({
  announcement,
  publishedAt,
  optionalLink = false,
}) => {
  const normalizedOptionalLink = typeof optionalLink === 'string' ? optionalLink.trim() : ''

  return (
    <>
      {normalizedOptionalLink ? (
        <Link
          href={normalizedOptionalLink}
          target="blank"
          className="w-[1080px] min-h-[50px] flex justify-between items-center mt-[30px] text-[16px]"
        >
          <div className="flex text-base w-full announcement-rectangle items-center h-full">
            <IonIcon className="flex-shrink-0 bellShape" name="notifications-outline" />
            <div className="announcement-versio flex flex-row flex-grow ml-[13px] items-center h-full">
              <span className="font-semibold">Announcement:</span>
              <p className="ml-[6px]">{announcement}</p>
            </div>
            <div className="text-xs text-gray-500 ml-[15px] whitespace-nowrap published flex items-center h-full">
              Published {formatNumericDisplayDate(publishedAt)}
            </div>
          </div>
        </Link>
      ) : (
        <div className="w-[1080px] min-h-[50px] flex justify-between items-center mt-[30px] text-[16px]">
          <div className="flex text-base w-full announcement-rectangle items-center h-full">
            <IonIcon className="flex-shrink-0 bellShape" name="notifications-outline" />
            <div className="announcement-versio flex flex-row flex-grow ml-[13px] items-center h-full">
              <span className="font-semibold">Announcement:</span>
              <p className="ml-[6px]">{announcement}</p>
            </div>
            <div className="text-xs text-gray-500 ml-[15px] whitespace-nowrap published flex items-center h-full">
              Published {formatNumericDisplayDate(publishedAt)}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
